module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Geltwil-38125d39fc8a1ba67b5ec9bdb642c188.svg";